import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import DownloadApp from "@/components/DownloadApp";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Pricing />
      <DownloadApp />
      <Contact />
      <Footer />
    </div>
  );
}
